import Capa from './Capa';
import { tooltip_municipios } from '@/components/mapa/capas/_utils.js';

const VIH_MUNICIPIOS_LAYER_NAME = 'vih:municipios_poligonos';

const columnasPorDefeco = ['nom_mun','tot_muestras','cvegeomun','geom'];

// 
export default class VihMunicipios extends Capa {

  constructor() {
    super({
      capa: VIH_MUNICIPIOS_LAYER_NAME, 
      titulo: 'Municipios',
      z_index: 1,
    })

    this.estilo = {
      fill: { color: 'transparent' },
        stroke: { color: 'gray' },
    }

    this.tooltip = tooltip_municipios;

    this.wfs.columnas = columnasPorDefeco;
  }

}
